import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {PhoneNumberMaxLengthDirective} from "./phoneNumber-MaxLength.directive";

@NgModule({
  declarations: [PhoneNumberMaxLengthDirective],
  imports: [
    CommonModule
  ],
  exports: [PhoneNumberMaxLengthDirective]

})
export class DirectiveModule { }
